exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brand-font[data-v-39ecc5e6]{font-family:Playfair Display,serif}", ""]);

// exports
